import "../../../styles/responsiveRow.scss";

import PropTypes from "prop-types";
import React from "react";

/**
 * Returnerar action för enhetens skärmstorlekstyp enligt bootstraps indelning i xs, sm, etc.
 * 
 * @param {object} props
 * @returns {node}
 */
function ResponsiveColumn({className, children, style}) {
    return (
        <div className={`responsive-column ${className}`} style={style}>
            {children}
        </div>
    );
}

ResponsiveColumn.propTypes = {
    xs: PropTypes.number,
    sm: PropTypes.number,
    md: PropTypes.number,
    lg: PropTypes.number,
    xl: PropTypes.number,
    children: PropTypes.node,
    style: PropTypes.object,
    className: PropTypes.string,
};

ResponsiveColumn.defaultProps = {
    xs: 12
};

export default ResponsiveColumn;